import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { Toaster } from "react-hot-toast";
import { Header } from "./components";
import { Provider } from "react-redux";
import { coreStore } from "./store";

function App() {
  return (
    <Provider store={coreStore}>
      <Header />
      <div className="page-wrapper">
        <RouterProvider router={router} />
      </div>
      <Toaster />
    </Provider>
  );
}

export default App;
